/**
 * Le micro a-t-il déjà été obtenu dans cette page ?
 *
 * Un navigateur ne repose pas la question d'un accès qu'il a donné à la page : une fois le micro
 * ouvert par le test d'entrée ou par le live, la salle peut le rouvrir sans geste (une reconnexion, un
 * passage en Dialogue). Ce qui ne survit pas, c'est la page : un rechargement repart de zéro, et
 * Safari, réglé sur « Demander », repose la question — sans geste, il la pose au milieu du live, et un
 * refus vaut pour toute la page (prod, 22/10).
 *
 * L'état de la page, donc d'un module : il naît et meurt avec elle. Sans objet sur le natif, où l'accès
 * est celui de l'app.
 */
let granted = false

/** Une demande du micro vient d'aboutir dans cette page. */
export function markMicrophoneGranted(): void {
    granted = true
}

export function microphoneGrantedInPage(): boolean {
    return granted
}

/** Les tests repartent d'une page neuve. */
export function resetMicrophoneGrantForTests(): void {
    granted = false
}
